var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"hamburger",class:{'hamburger--active': _vm.menuOpen },attrs:{"type":"button"},on:{"click":function($event){return _vm.toggleMenu(!_vm.menuOpen)}}},[_c('span',{staticClass:"hamburger__inner"})])}
var staticRenderFns = []

export { render, staticRenderFns }